
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import cashierSearchTpl from '!!file-loader?name=templates/[name].[ext]!./cashierSearch.html';

/**
 * Directive used for manipulate the HTML DOM elements inside the sellerCashierSearch component
 */
function cashierSearchComponent() {

	/**
	 * Directive definition
	 */
	const directive = {
		restrict: 'E',
		templateUrl: cashierSearchTpl,
		controller: CashierSearchController,
		controllerAs: 'cashiersearchvm',
		bindToController: true,
		scope: {
			reciver: '='
		}
	};

	return directive;

	function CashierSearchController(utilitiesConstant, utilitiesFactory, restClientServices, sessionFactory, cashierSearchConstant) {
		'ngInject';
		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		const user = angular.fromJson(sessionFactory.get(utilitiesConstant.STORAGE.USER));
		let vm = this;

		vm.searchCashierText = '';
		vm.cashiers = [];
		vm.constant = cashierSearchConstant;

		/**
 		* Filters chasier by name and username
 		*/
		vm.searchCashier = searchText => vm.cashiers.filter(cashier => _.includes(cashier.name.toLowerCase(), searchText.toLowerCase()) || _.includes(cashier.identification, searchText));

		(function () {
			/**
			 * Gets sellers and cashiers from the server
			 */
			const cashiersUrl = utilitiesConstant.URL_ENDPOINT_GANA.concat(utilitiesConstant.URL_API_METHOD.SELLERS_CASHIERS);

			restClientServices.ganaService(cashiersUrl, { userId: user.office.code })
				.then(response => {
					vm.cashiers = response.cashiers;
				},
				error => {
					if (error.status === 404) {
						utilitiesFactory.showAlertMessage(cashierSearchConstant.NOT_FOUND_CASHIERS);
					} else {
						utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
					}
				});
		})();
	}
}

export default cashierSearchComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/cashierSearch/cashierSearch.directive.js